module.exports = __webpack_public_path__ + "img/footer.6a896163.png";